import type { KeyboardEvent } from 'react';

/** Handle submission on keydown, without leaking chat keystrokes into Unity. */
export function handleChatInputKeyDown(event: KeyboardEvent<HTMLInputElement>, send: () => void): void {
  event.stopPropagation();
  if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing || event.keyCode === 229) return;
  event.preventDefault();
  // Holding Enter must not submit the same draft repeatedly.
  if (!event.repeat) send();
}
